/** Calendar date helpers that never shift a day via UTC (`toISOString`). */

export function toLocalYmd(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export function parseLocalYmd(value: string | null | undefined): Date | null {
    if (!value) return null;
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value.trim());
    if (!m) return null;
    const y = Number(m[1]);
    const month = Number(m[2]);
    const d = Number(m[3]);
    const date = new Date(y, month - 1, d);
    if (date.getFullYear() !== y || date.getMonth() !== month - 1 || date.getDate() !== d) {
        return null;
    }
    return date;
}

export function todayLocalYmd(): string {
    return toLocalYmd(new Date());
}
